<template>
  <CCard>
    <CCardHeader>
      <h2>予定超過残業の申請詳細</h2>
    </CCardHeader>
    <CCardBody>
      <CAlert v-if="errorMessage" color="danger">{{ errorMessage }}</CAlert>
      <div v-if="loading" class="d-flex align-items-center py-4">
        <CSpinner color="primary" class="mr-2"/>
        <span>予定超過残業の申請を読み込んでいます。</span>
      </div>
      <CRow v-else-if="loaded">
        <div class="container">
          <table class="table">
            <tr>
              <th scope="row">申請ユーザ名</th>
              <td>{{ user_name }}</td>
            </tr>
            <tr>
              <th scope="row">更新日</th>
              <td class="preika-report-detail-date">{{ updated_at }}</td>
            </tr>
            <tr>
              <th scope="row">予定時間外勤務時間</th>
              <td class="preika-report-detail-duration">{{ overtime }}時間</td>
            </tr>
            <tr>
              <th scope="row">発生理由</th>
              <td class="preika-report-detail-reason">{{ reason }}</td>
            </tr>
          </table>
        </div>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from 'axios'
import { safeErrorDigest } from '../../utils/safeResponseMessage'

export default {
  name: 'AdminOvertimeInfo',
  data () {
    return {
      id: null,
      user_name: '',
      overtime: 0,
      updated_at: '',
      reason: '',
      loading: false,
      loaded: false,
      errorMessage: ''
    }
  },
  watch: {
    '$route.params.id': 'loadOvertime'
  },
  mounted () {
    this.loadOvertime()
  },
  methods: {
    async loadOvertime () {
      this.errorMessage = ''
      this.loaded = false
      const parsedId = Number(this.$route.params.id)
      if (!Number.isSafeInteger(parsedId) || parsedId <= 0) {
        this.errorMessage = '予定超過残業の申請を特定できません。一覧から選択し直してください。'
        return
      }

      this.id = parsedId
      this.loading = true
      try {
        // 管理者一覧から開くため、本人専用 /overtime/{id} ではなく
        // APPROVAL_MANAGEとセッション企業境界を強制する管理者APIを使用する。
        const response = await axios.get(
          `${process.env.VUE_APP_API_ORIGIN}/admin/overtime/${this.id}`
        )
        const data = response.data || {}
        this.user_name = data.user_name || ''
        this.overtime = data.overtime == null ? 0 : data.overtime
        this.updated_at = data.updated_at || ''
        this.reason = data.reason || ''
        this.loaded = true
      } catch (error) {
        this.errorMessage = '予定超過残業の申請を取得できませんでした。画面を再読み込みしてください。'
        console.error('管理者予定外時間外詳細取得失敗:', safeErrorDigest(error))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
</style>
